const InputPlace = ({ place, handleInputPlace }) => {
    return (
        <input
            id='place-input'
            className='place-input-style'
            value={place}
            onChange={handleInputPlace}
        />
    );
};

export default InputPlace;